export const firebaseConfig = {
    apiKey: "AIzaSyB8p6580jKc9JY2_DDaTOMxqaqDJ10IzMo",
    authDomain: "chaitime-web.firebaseapp.com",
    projectId: "chaitime-web",
    storageBucket: "chaitime-web.appspot.com",
    messagingSenderId: "560188755333",
    appId: "1:560188755333:web:deac24adb4d26604c088ec"
};
